// ==================== IMPORTS ====================
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { FUNDING, PayPalButtons } from "@paypal/react-paypal-js";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { depositLimtApi } from "../../Services/prod/auth.service";

function PaypalWebview() {
  // ==================== STATES ====================
  const [searchParams] = useSearchParams();
  const tokenId = searchParams.get("token");
  const amountUrl = searchParams.get("amount");
  const [userDetail, setUserDetail] = useState({});
  const [depositlimit, setDepositLimit] = useState(0);
  const [showPayPal, setShowPayPal] = useState(true);
  const [depositMessage, setDepositMessage] = useState(false);

  // ==================== INITIAL VALUES ====================
  const initialValues = {
    amount: amountUrl,
    choice: "USD",
  };

  // ==================== VALIDATION SCHEMA ====================
  const validationSchema = Yup.object({
    amount: Yup.number()
      .typeError("Amount must be a number")
      .required("Amount is required")
      // .min(0, "Amount must be a positive number")
      // .max(10000, "Amount must not exceed 10000")
      .test(
        "kyc-deposit-validation",
        "Deposit is not allowed until KYC is approved",
        function (value) {
          if (value > depositlimit) {
            return userDetail?.kyc_status === "APPROVED";
          }
          return true;
        }
      ),
    choice: Yup.string().required("Please select an option"),
  });

  // // ==================== SHOW PAYPAL BUTTONS ====================
  // const handleSubmit = (values) => {
  //   if (values) {
  //     setShowPayPal(true);
  //   }
  // };

  // ==================== PAYPAL DEPOSIT FUNCTION ====================
  const handleDeposit = async (paymentResult, resetForm) => {
    try {
      const webViewPayload = {
        payload: paymentResult,
      };
      const response = await fetch(
        `${process.env.REACT_APP_STAGE_API_URL}users/v1/paypal/deposit-via-webview`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenId}`,
          },
          body: JSON.stringify(webViewPayload),
        }
      );
      if (response?.status === 200) {
        setDepositMessage(true);
        setShowPayPal(false);
        resetForm();
      }
    } catch (error) {
      console.error("Error depositing:", error);
    }
  };

  // ==================== PAYPAL HANDLE ERROR ====================
  function onError() {
    try {
      console.log("Error");
      setShowPayPal(false);
    } catch (error) {
      console.log(error);
    }
  }

  // ==================== USER DETAILS TO GET (KYC,USERID) ====================
  const fetchData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_STAGE_API_URL}users/v1/user/user_details`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenId}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("API fetch error:", error.message);
    }
  };

  // ==================== FOR DEPOSIT VALIDATION LIMIT KYC ====================
  useEffect(() => {
    const depositValidation = async () => {
      if (tokenId) {
        try {
          const [depositLimtRes, userDetailRes] = await Promise.all([
            depositLimtApi(),
            fetchData(),
          ]);
          if (depositLimtRes && userDetailRes?.status === 200) {
            setDepositLimit(depositLimtRes?.KYCLimit);
            setUserDetail(userDetailRes?.data);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    };
    depositValidation();
  }, []);

  return (
    <div
      className="influencer_enrollment_page"
      style={{
        // display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f7f7f7",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "30px",
          borderRadius: "8px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          width: "400px",
          maxWidth: "100%",
        }}
      >
        {!showPayPal && !depositMessage && (
          <h2
            style={{
              textAlign: "center",
              fontSize: "24px",
              marginBottom: "20px",
            }}
          >
            Add Funds
          </h2>
        )}
        {depositMessage && (
          <h2
            style={{
              textAlign: "center",
              fontSize: "24px",
              marginBottom: "20px",
              color: "red",
            }}
          >
            Note
          </h2>
        )}
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          // onSubmit={handleSubmit}
        >
          {({ values, resetForm }) => (
            <Form>
              {/* {!showPayPal && !depositMessage && (
                <>
                  <div style={{ marginBottom: "15px" }}>
                    <label
                      htmlFor="amount"
                      style={{
                        display: "block",
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      Amount
                    </label>
                    <Field
                      type="text"
                      id="amount"
                      name="amount"
                      placeholder="Enter the amount"
                      style={{
                        width: "100%",
                        padding: "10px",
                        marginTop: "5px",
                        borderRadius: "4px",
                        border: "1px solid #ddd",
                        fontSize: "14px",
                        outline: "none",
                      }}
                      onPaste={(event) => {
                        const pastedData = event.clipboardData.getData("text");

                        if (!/^\d+$/.test(pastedData)) {
                          event.preventDefault();
                        }
                      }}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      autoComplete="off"
                      disabled
                    />
                    <ErrorMessage
                      name="amount"
                      component="div"
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "5px",
                      }}
                    />
                  </div>

                  <div style={{ marginBottom: "20px" }}>
                    <label
                      htmlFor="choice"
                      style={{
                        display: "block",
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      Select an option
                    </label>
                    <Field
                      as="select"
                      id="choice"
                      name="choice"
                      style={{
                        width: "100%",
                        padding: "10px",
                        marginTop: "5px",
                        borderRadius: "4px",
                        border: "1px solid #ddd",
                        fontSize: "14px",
                        outline: "none",
                      }}
                      disabled
                    >
                      <option value="" label="Select an option" />
                      <option value="USD" label="USD" />
                      <option value="MXN" label="MXN" />
                    </Field>
                    <ErrorMessage
                      name="choice"
                      component="div"
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "5px",
                      }}
                    />
                  </div>

                  <div style={{ textAlign: "center" }}>
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      style={{
                        padding: "10px 20px",
                        backgroundColor: "#007bff",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                        fontSize: "16px",
                        transition: "background-color 0.3s ease",
                      }}
                    >
                      Submit
                    </button>
                  </div>
                </>
              )} */}
              {depositMessage && (
                <p
                  style={{
                    fontSize: "16px",
                    lineHeight: "1.6",
                    color: "#333",
                    margin: "20px 0",
                    textAlign: "center",
                  }}
                >
                  Your Payment is being processed and can take up to 5 minutes
                  to appear in your wallet. You can see the record of this
                  transaction and the balance of your wallet in the transaction
                  history section.
                </p>
              )}

              {showPayPal && values?.amount && values?.choice && (
                <PayPalButtons
                onClick={(data, actions) => {
                  data.fundingSource &&
                    window?.ReactNativeWebView?.postMessage(
                      "open_paypal_browser"
                    );
                  return actions.resolve();
                }}
                  createOrder={(data, actions) => {
                    const amountWithoutCommas = values?.amount.replace(
                      /,/g,
                      ""
                    );
                    const amount = parseFloat(amountWithoutCommas);
                    return actions?.order?.create({
                      purchase_units: [
                        {
                          reference_id: userDetail?.user_id,
                          amount: {
                            value: amount,
                            currency: values?.choice,
                          },
                        },
                      ],
                    });
                  }}
                  onApprove={(data, actions) => {
                    return actions.order.capture().then((paymentResult) => {
                      handleDeposit(paymentResult, resetForm);
                    });
                  }}
                  onError={onError}
                />
              )}
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default PaypalWebview;
